import React from "react";
import ClientLayerBlueprint from "components/blueprints/ClientLayerBlueprint";
import ClientNotificationsOverview from "./ClientNotificationsOverview";
import ClientNotificationsList from "./ClientNotificationsList";

function ClientNotificationsPage() {
  return (
    <div className="min-h-screen bg-gray-100 py-2">
      <div className="container mx-auto my-6 flex">
        <section id="left" className="w-1/4 pr-2">
          <ClientNotificationsOverview />
        </section>
        <section id="right" className="w-3/4 pl-2">
          <ClientNotificationsList />
        </section>
      </div>
    </div>
  );
}

export default ClientLayerBlueprint(ClientNotificationsPage);
